import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminAppBar from "../adminComponents/AdminAppBar";
import axios from "axios";
import LeadUploadService from "../Services/LeadUploadService";
import leadSourceService from "../Services/LeadSourceService";
import InterestedTagService from "../Services/InterestedTagService";
import propertyService from "../Services/PropertyService";
import teamService from "../Services/TeamService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { leadStatusMap } from "../../Enum";
import { interestLevel} from '../../Enum/LeadEnumConstants';
import AppBar from "../leadComponent/AppBar";
import { showErrorToast, showSuccessToast } from "../Constant/Notification";
import userServices from "../Services/UserService";
import LocationService from "../Services/LocationService";
import { getBasePathByUserRole } from "../../utils/roleRoutes";
import CustomSelect from "../common/CustomSelect";
import CustomHeading from "../common/CustomHeading";
import LeadSourceDropdown from "../Form/LeadTable/LeadSourceDropdown";
import AsteriskStyle from "../Form/Tooltip/AsteriskStyle";
import { Divider } from "../Constant/Constant";
import { GLPagePropertyTypeList } from "../../Enum/GLPageEnumConstants";
import PropertiesService from "../Services/PropertiesService";
import { Search } from "lucide-react";
import debounce from "lodash.debounce";
import { f } from "html2pdf.js";

const AdminManualUpload = () => {
  const navigate = useNavigate();

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const bodTeamId = userObj?.teamId?.[0]?.id;

  const path = getBasePathByUserRole();



  const [interestTags, setInterestTags] = useState([]);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [options, setOptions] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [inputJson, setInputJson] = useState(null);
  const [leadSource, setLeadSource] = useState([]);
  const [leadSourceSearch, setLeadSourceSearch] = useState("");
  const [properties, setProperties] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState("");
  const [isAssignedTeam, setIsAssignedTeam] = useState(false);
  const [isAssignedUser, setIsAssignedUser] = useState(false);
  const [budget, setBudget] = useState();

  const [fieldWorkers, setFieldWorkers] = useState([]);

  const [interestedTags, setInterestedTags] = useState([]);
  const [leadGivenUsers, setLeadGivenUsers] = useState([]);
  const [selectedLeadGivenBy, setSelectedLeadGivenBy] = useState();
  const [selectedPropertyType, setSelectedPropertyType] = useState();
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [selectedProperty, setSelectedProperty] = useState("");
  const [propertyList, setPropretyList] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedSourceType, setSelectedSourceType] = useState(userRole === 'BOD' ? false : true);


  const [selectedStatus, setSelectedStatus] = useState(
    leadStatusMap?.["Fresh"] || ""
  );

console.log("selectedProperty" ,selectedProperty)

  const [selectedFieldWorker, setSelectedFieldWorker] = useState("");
  const [users, setUsers] = useState([]);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState();
  const [emailId, setEmailId] = useState("");
  const [errors, setErrors] = useState({});
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  const [selectedLevel, setSelectedLevel] = useState();

  const handleSelectChange = (selectedOption) => {
    setSelectedLevel(selectedOption);
  };


  const handleAddLead = async () => {
    if (!validateForm()) return;
    setLoading(true);

    try {
      const tags = interestTags.map((item) => item.value);
      const locationTags = interestLocationTags.map((item) => item.value);

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailId && !emailRegex.test(emailId)) {
        showErrorToast("Invalid email ID. Please enter a valid email ID.");
        return;
      }

      
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(phone)) {
        toast.error(
          "Invalid phone number. Please enter a 10-digit phone number.",
          {
            position: "top-center",
            theme: "light",
            className: "absolute top-20",
          }
        );
        return;
      }

      const commonObj = {
        createdBy: userObj.user.uid,
        modifiedBy: userObj.user.uid,
        fieldWorker: selectedLeadGivenBy?.value,
        interestTags: tags,
        interestedLocations: locationTags,
        leadSource: selectedLeadSource?.id || "",
        leadQuality: selectedLevel?.value || "",
     
            name: name?.toLowerCase() || "",
            phoneNumber: String(phone),
            countryCode: "91",
            emailId: emailId || "",
   
        status: selectedStatus || "",
        sourceType : selectedSourceType || false,
        interestedPropertyId : selectedProperty?.value || null,
        interestedCategoryId : selectedPropertyType?.value || null,
      };

      let obj = {};



      if (["Admin", "CMO", "Lead Uploader"].includes(userRole)) {
        obj = {
          ...commonObj,
          assignedTeam: selectedTeam.value,
          assignedUser: isAssignedUser ? selectedUser?.value : "",
        };
      } else if (userRole === "BOD") {
        obj = {
          ...commonObj,
          assignedTeam: bodTeamId,
          assignedUser: selectedUser?.value,
        };
      }
      
   

      const response = await LeadUploadService.createBulkUpload(obj);
      console.log(response);

      if (response.status === 200) {
        showSuccessToast(response?.data?.message || "Lead uploaded successfully");
      } 

      setTimeout(() => navigate(-1), 1500);
    } catch (error) {
      console.error(error);
      if(error){
        showErrorToast(error?.response?.data);
        setPhone("")
      }
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      showErrorToast("Name is required");
      return;
    } else if (!phone) {
      showErrorToast("Phone number is required");
      return;
    } else if (!selectedLevel) {
      showErrorToast("Lead Quality is required");
      return;
    } else if (!selectedLeadSource) {
      showErrorToast("Lead Source is required");
    } else if (userRole !== "BOD" && !selectedTeam) {
      showErrorToast("Team is required");
    } else if (!selectedStatus) newErrors.status = "Status is required";

    // if (!name.trim()) newErrors.name = "Name is required";
    // if (!phone) newErrors.phone = "Phone number is required";
    // if (userRole !== "BOD") {
    //   if (!selectedTeam) newErrors.teams = "Team is required";
    // }
    // if (!selectedLeadSource) {
    //   showErrorToast("Lead Source is required");
    // }
    // // if (interestTags.length === 0)
    // //   showErrorToast("Interested Tag is required");
    // if (!selectedStatus) newErrors.status = "Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (selectedOptions) => {
    setInterestTags(selectedOptions);
  };

  const handleLeadGiveUser = (selectedOptions) => {
    setSelectedLeadGivenBy(selectedOptions);
  };

  const handleLocationChange = (event) => {
    setInterestedLocationTags(event);
  };

  const handlePropertyType = (selectedPropertyType) => {
    setSelectedPropertyType(selectedPropertyType);
  };

  const handlePropertyChange = (selected) => {
    setSelectedProperty(selected);
  };

  const handleSelectedUser = (selectedUser) => {
    setSelectedUser(selectedUser);
  };

  const handelSelectedTeam = (selectedTeam) => {
    setSelectedTeam(selectedTeam);
    setSelectedUser("");
  };

  const handleBudgetChange = (e) => {
    setBudget(e.target.value);
  };

  // const fetchLeadSourceData = async () => {
  //   try {
  //     const response = await leadSourceService.getLeadSource(leadSourceSearch);
  //     const data = response.data;
  //     console.log(data);
  //     setLeadSource(data || []);
  //   } catch (error) {
  //     console.error("Error fetching leadSources:", error);
  //     setLeadSource([]);
  //   }
  // };
  // useEffect(() => {
  //   fetchLeadSourceData();
  // }, [leadSourceSearch]);

  // const loadPropertyOptions = async (inputValue) => {
  //   if (!inputValue?.trim()) return [];
  //   const response = await PropertiesService.getPropertyList(inputValue);
  //   return response.map((item) => ({
  //     value: item.id,
  //     label: item.name,
  //   }));
  // };

  // useEffect(()=>{
  //   loadPropertyOptions()
  // },[])

  useEffect(() => {
    (async () => {
      try {
        const responseTags = await InterestedTagService.fetchInterestedTag();
        const responseLocation = await LocationService.fetchLocation();

        const dataLocation = responseLocation.data;
        const formattedLocations = Object.entries(dataLocation).map(
          ([name, id]) => ({
            value: id,
            label: name,
          })
        );

        setOptionLocation(formattedLocations);
        console.log("Interest Location Data:", formattedLocations);

        const dataTags = responseTags.data;
        console.log("Interest Data:", dataTags);
        setInterestedTags(dataTags);

        const optionsArray = dataTags.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptions(optionsArray);
      } catch (error) {
        console.error("Error fetching interested tags:", error);
      }

      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams || [];

        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }

      try {
        const response = await teamService.getUserName();
        const data = response.data?.users || [];
        const userData = data.map((list) => ({
          value: list.id,
          label: list.name,
        }));
        setLeadGivenUsers(userData);
      } catch (error) {
        console.log(error.message);
      }
    })();
  }, []);



  const fetchPropertyList = async (inputValue)=>{
 
    try {
      const response = await PropertiesService.getPropertyList(inputValue);
      const propertyData = response.data?.map((list) => ({
        value: list.id,
        label: list.name,
      }));
      setPropretyList(propertyData);
      console.log("propertyData" , response)
    } catch (err) {
      console.error("Failed to fetch property list", err);
    }
  }
  useEffect(()=>{
    fetchPropertyList("")
  },[])

  const handleInputChange = (newValue) => {
    fetchPropertyList(newValue);
  };
  


  const handleLeadAssignChange = (type) => {
    if (type === "Assign to team") {
      setIsAssignedTeam(true);
      setIsAssignedUser(false);
    } else if (type === "Assign to user") {
      setIsAssignedTeam(true);
      setIsAssignedUser(true);
    }
  };

  const handleTeamChange = async (e) => {
    setSelectedTeam(e);
    setErrors((prevErrors) => ({ ...prevErrors, teams: "" }));
  };

  useEffect(() => {
    const fetchUsersByTeam = async () => {
      let teamIdToFetch = userRole === "BOD" ? bodTeamId : selectedTeam.value;
      if (teamIdToFetch) {
        console.log(selectedTeam);
        try {
          const response = await teamService.getTeamData(teamIdToFetch); // Pass selectedTeam
          const data = response.data;
          console.log(data);
          const combinedUsers = [
            ...(Array.isArray(data.BOD) && data.BOD.length > 0
              ? data.BOD.map((bod) => ({ name: bod.name, id: bod.id }))
              : []),
            ...(data.MD && data.MD.name !== null && data.MD.id !== null
              ? [{ name: data.MD.name, id: data.MD.id }]
              : []),
            ...(Array.isArray(data.members) && data.members.length > 0
              ? data.members.map((member) => ({
                  name: member.name,
                  id: member.id,
                }))
              : []),
          ];

          const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];

          console.log("Final Users:", finalUsers);

          setUsers(finalUsers);
          console.log(users);
        } catch (error) {
          console.error("Error fetching users by team:", error);
          showErrorToast("Error fetching users");
        }
      }
    };

    fetchUsersByTeam();
  }, [selectedTeam, isAssignedUser]);
  const handleLeadSourceChange = (e) => {
    setSelectedLeadSource(e);
    setSelectedLeadSourceId(e.value);

    setErrors((prevErrors) => ({ ...prevErrors, leadSources: "" }));
  };

  // const handleStatusChange = (e) => {
  //   console.log(e);
  //   setSelectedStatus(leadStatusMap["Fresh"]);
  //   setErrors((prevErrors) => ({ ...prevErrors, status: "" }));
  // };

  const handleNameChange = (e) => {
    // setName(e.target.value);
    setName(
      e.target.value.replace(/\d/g, "").charAt(0).toUpperCase() +
        e.target.value.replace(/\d/g, "")
    );
  };

  const handlePhoneChange = (e) => {
    const newPhoneNumber = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPhone(newPhoneNumber.slice(0, 10)); // Limit to 10 digits
    setPhoneNumberError(
      newPhoneNumber.length !== 10 || /\D/.test(newPhoneNumber)
    );
    setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
  };

  const handleEmailChange = (e) => {
    setEmailId(e.target.value.toLowerCase());
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };

  console.log("selected Property ", selectedProperty)
  return (
    <div className="bg-appGrayBackground">
      {userRole === "Lead Uploader" ? <AppBar /> : <AdminAppBar />}
      <ToastContainer />
      <div className=" bg-appGrayBackground flex flex-col gap-8  mt-20 pt-4 px-6 pb-10">
        <div className="flex justify-between">
          <CustomHeading title={"Manual Upload"} isIcon={true} />

          <div className="">
            <button
              onClick={handleAddLead}
              className={`px-3 py-3 w-44 text-center ${
                loading ? "bg-gray-400 cursor-not-allowed" : "bg-customGreen"
              } text-white flex items-center text-base font-medium justify-center gap-2 rounded-[10px] transition duration-300`}
              disabled={loading}
            >
              Add Lead
            </button>
          </div>
        </div>

        <form className="flex flex-col px-[70px] mx-10 py-[37px] bg-white shadow rounded-[10px] h-full ">
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-xl font-medium"
              htmlFor="name"
            >
              Source Type <AsteriskStyle />
            </label>

            <div className="flex gap-8 items-center">
              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  id="manual"
                  name="sourceType"
                  value="Manual"
                  className="w-5 h-5 "
                  checked={selectedSourceType === true}
                  onChange={(e)=>{
                    setSelectedSourceType(true)
                  }}
                />
                <label>Managment Lead</label>
              </div>

              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  id="manual"
                  name="sourceType"
                  value="Manual"
                  className="w-5 h-5 "
                  checked={selectedSourceType === false}
                  onChange={(e)=>{
                    setSelectedSourceType(false)
                  }}
                />
                <label>Own Lead</label>
              </div>
            </div>
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Lead Given By{" "}
            </label>
            <div className="flex w-3/4 relative">
              <CustomSelect
                value={selectedLeadGivenBy}
                onChange={handleLeadGiveUser}
                options={leadGivenUsers}
                placeholder="Select Lead Given By"
              />
            </div>
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Lead Source <span className="text-red-600">*</span>
            </label>
            <div className="flex w-3/4">
              <LeadSourceDropdown
                leadSource={leadSource}
                setLeadSourceSearch={setLeadSourceSearch}
                leadSourceSearch={leadSourceSearch}
                onSelect={(list) => {
                  setSelectedLeadSource(list);
                }}
              />
            </div>
          </div>

          <div className="mb-8 ">
            <hr className="border-t border-gray-300 mx-4" />
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Name <span className="text-red-600">*</span>
            </label>
            <input
              className={` appearance-none border  w-3/4 py-3 rounded-[10px] px-2 focus:outline-customGreen  text-gray-700 leading-tight  ${
                errors.name && "border-red-500"
              }`}
              id="name"
              type="text"
              value={name}
              maxLength={50}
              placeholder={errors.name || "Enter User Name"}
              // onChange={(e) => handleNameChange(e)}
              onChange={(e) => {
                setName(
                  e.target.value.replace(/\d/g, "").charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                );
                setErrors((prevErrors) => ({ ...prevErrors, name: "" }));
              }}
            />
          </div>
          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Phone Number <span className="text-red-600">*</span>
            </label>

            <input
              className={` appearance-none border  w-3/4 py-3 rounded-[10px] px-2 focus:outline-customGreen  text-gray-700 leading-tight  ${
                errors.phone && "border-red-500"
              }`}
              id="phone-number"
              type="tel"
              pattern="[0-9]{10}"
              value={phone}
              placeholder={
                phoneNumberError
                  ? "Invalid phone number format"
                  : "Enter Phone Number"
              }
              onChange={handlePhoneChange}
            />
          </div>
          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Email ID
            </label>
            <input
              className="shadow appearance-none border  w-3/4 py-3 px-2 text-gray-700 leading-tight rounded-[10px] focus:outline-customGreen"
              id="email"
              type="email"
              value={emailId}
              placeholder="Enter your email"
              onChange={(e) => handleEmailChange(e)}
            />
          </div>
          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Lead Quality <span className="text-red-600">*</span>
            </label>
            <div className="w-3/4 ">
              <CustomSelect
                value={selectedLevel}
                placeholder="Select Lead Quality"
                onChange={handleSelectChange}
                options={interestLevel}
              />
            </div>
          </div>
          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Interest Category
            </label>
            <div className="w-3/4 ">
              <CustomSelect
                value={selectedPropertyType}
                onChange={handlePropertyType}
                options={GLPagePropertyTypeList.map((type) => ({
                  value: type.id,
                  label: type.label,
                }))}
                placeholder="Interest property type"
              />
            </div>
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Interest Property
            </label>
            <div className="w-3/4 ">
              <CustomSelect
                value={selectedProperty}
                onChange={handlePropertyChange}
                onInputChange={handleInputChange}
                options={propertyList}
                placeholder="Interest property"
              />
            </div>
          </div>

          <div className="mb-8 flex  items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Interest Tag
            </label>
            <div className="flex w-3/4   ">
              <CustomSelect
                value={interestTags}
                onChange={handleChange}
                options={options}
                isMulti
                placeholder="Type Interest Tags"
              />
            </div>
          </div>

          <div className="mb-8 flex  items-center">
            <label className="w-1/4 text-black text-xl font-medium ">
              Interest locations
            </label>
            <div className="flex w-3/4   ">
              <CustomSelect
                value={interestLocationTags}
                onChange={handleLocationChange}
                options={optionLocation}
                isMulti
                placeholder="Type Interest Location"
              />
            </div>
          </div>

          <div className="mb-8 ">
            <hr className="border-t border-gray-300 mx-4" />
          </div>

          <div className="flex items-center mb-4">
            {userRole !== "BOD" && (
              <div className="mb-8 flex w-full items-center">
                <label className="w-1/4 text-black text-xl font-medium ">
                  Assign To <AsteriskStyle />
                </label>
                <div className="w-3/4 flex  gap-10">
                  <div className="flex items-center gap-3">
                    <input
                      type="radio"
                      value="Assign to team"
                      id="assign-team"
                      className="w-5 h-5"
                      checked={isAssignedTeam && !isAssignedUser}
                      onChange={() => handleLeadAssignChange("Assign to team")}
                    />
                    <label htmlFor="" className="flex gap-2">
                      Assign to team
                    </label>
                  </div>

                  <div className="flex items-center gap-3">
                    <input
                      type="radio"
                      value="Assign to user"
                      id="assign-user"
                      className="w-5 h-5"
                      checked={isAssignedUser}
                      onChange={() => handleLeadAssignChange("Assign to user")}
                    />
                    <span>Assign to user</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {isAssignedTeam && userRole !== "BOD" && (
            <div className="mb-8 flex items-center">
              <label className="w-1/4 text-black text-xl font-medium ">
                Assign to team <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                {/* <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => handleTeamChange(e.target.value)}
                >
                  <option value="">Select Team</option>
                  {teams.map((item, index) => (
                    <option key={index} value={item.teamId}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
                <CustomSelect
                  options={teams.map((list) => ({
                    value: list.teamId,
                    label: list.name,
                  }))}
                  onChange={handelSelectedTeam}
                  value={selectedTeam}
                />
              </div>
            </div>
          )}

          {(isAssignedUser || userRole === "BOD") && (
            <div className="mb-8 flex items-center">
              <label className="w-1/4 text-black text-xl font-medium ">
                Assign to user <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                {/* <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="">Select User</option>
                  {users.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
                <CustomSelect
                  value={selectedUser}
                  options={users.map((list) => ({
                    value: list.id,
                    label: list.name,
                  }))}
                  onChange={handleSelectedUser}
                />
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AdminManualUpload;
